import * as yup from 'yup';

export const schemaCrmCampaign = yup.object().shape({
  name: yup
    .string()
    .required('Nome da campanha é obrigatório')
    .min(3, 'Nome deve ter pelo menos 3 caracteres')
    .max(150, 'Nome deve ter no máximo 150 caracteres'),
  category: yup
    .string()
    .required('Categoria é obrigatória')
    .oneOf(
      ['LEAD', 'RETENTION', 'BIRTHDAY', 'TREATMENT_RETURN', 'OFFICE', 'OTHERS'],
      'Categoria inválida',
    ),
  message_type: yup
    .string()
    .required('Tipo de mensagem é obrigatório')
    .oneOf(['TEXT', 'TEMPLATE'], 'Tipo de mensagem inválido'),
  whatsapp_template_name: yup.string().when('message_type', {
    is: 'TEMPLATE',
    then: (schema) =>
      schema.required('Nome do template WhatsApp é obrigatório quando tipo é TEMPLATE'),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  template_id: yup.string().when('message_type', {
    is: 'TEMPLATE',
    then: (schema) =>
      schema.required('ID do template é obrigatório quando tipo é TEMPLATE'),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  message_body: yup.string().when('message_type', {
    is: 'TEXT',
    then: (schema) =>
      schema
        .required('Conteúdo da mensagem é obrigatório quando tipo é TEXT')
        .min(1, 'Conteúdo da mensagem não pode ser vazio'),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  schedule_type: yup
    .string()
    .oneOf(['NOW', 'SCHEDULED'], 'Tipo de agendamento inválido')
    .default('NOW'),
  audience_filters: yup.mixed().nullable().notRequired(),
});
